<template>
    <el-drawer
        title="众筹收入明细"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <div class="group">
                <div class="page-group-title"><span>销售汇总</span></div>
                <div class="MT20" >
                    <table v-if="data" class="info-table" width="100%">
                        <tr>
                            <th>众筹ID</th>
                            <td>{{data.id}}</td>
                            <th>众筹名称</th>
                            <td>{{data.title}}</td>
                        </tr>
                        <tr>
                            <th>目标筹款金额</th>
                            <td>{{data.raiseMoneyFormat}}</td>
                            <th>支持次数</th>
                            <td>{{data.num}}</td>
                        </tr>
                        <tr>
                            <th>已经筹款金额</th>
                            <td colspan="3" class="color-danger">{{data.raisedMoneyFormat}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>支付平台</span></div>
                <div class="MT20">
                    <table v-if="data" class="info-table" width="100%">
                        <tr v-for="(item,index) in data.payPlatforms" :key="index">
                            <th>{{item.name}}收入</th>
                            <td>{{item.payAmountFormat}}</td>
                            <th>{{item.name}}占比</th>
                            <td>{{item.payAmountRate}}%</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>回报项销售</span></div>
                <el-table
                    :data="data && data.tickets"
                    border
                    style="width: 100%"
                    size="small"
                    stripe
                    class="MT20"
                >
                    <el-table-column prop="ticketName" label="回报项" show-overflow-tooltip min-width="120"></el-table-column>
                    <el-table-column prop="num" label="支持次数"></el-table-column>
                    <el-table-column prop="amountFormat" label="筹款金额" min-width="100"></el-table-column>
                    <el-table-column prop="numRate" label="支持次数占比" min-width="100"></el-table-column>
                    <el-table-column prop="amountRate" label="筹款金额占比" min-width="100">
                        <template slot-scope="scope">{{scope.row.amountRate}}%</template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button type="primary" @click="close">确 定</el-button>
        </div>
    </el-drawer>
</template>
<script>
export default {
    data(){
        return{
            drawerShow: false,
            id:'',
            data: null,
            dataLoading: false
        }
    },
    methods:{
        close(){
            this.drawerShow = false;
        },
        show(id){
            this.id = id || '';
            if(id){
                this.getData();
            }
            this.drawerShow = true;
        },
        getData(){
            this.dataLoading = true;
            this.$request({
                url: '/raise/receivables/audi/sale/incomeDetail',
                params: {id: this.id},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result;
                    } else {
                        this.$message.error(msg || "获取明细信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取明细信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        }
    }
}
</script>